import React from "react";
import "./css/Policy.css";
const Policy = () => {
  return (
    <>
      <div className="container mb-5">
        <h1 style={{ textAlign: "center" }}>Privacy Policy</h1>
        <p>
          Effective Date: [Insert Date] <br />
          Last Updated: [Insert Date{" "}
        </p>
        <p style={{ textAlign: "justify" }}>
          <b>InstaPe Synergies Private Limited</b> (hereinafter referred to as
          <b>“Company”/“We”/“Us”</b>) has developed a platform (hereinafter
          referred to as <b>“InstaPe App”/“Application”</b>) that facilitates
          various services including but not limited to allowing <b>User(s)</b>{" "}
          (may alternatively be referred to as <b>“You”</b>, <b>“Customer”</b>{" "}
          or <b>“Employee"</b>) to withdraw an advance against the earned amount
          of salary at any point of time or avail a loan facility at an agreed
          rate of interest and processing fees and such facility may be extended
          by any Bank or NBFC (“Lending Institution”).
        </p>
        <p>
          The Company commits to deliver services through the Application that
          ensures an impermeable privacy protection to the Users of the InstaPe
          App.
        </p>
        <p style={{ textAlign: "justify" }}>
          This Privacy Policy shall explain the mechanism of how the collection,
          use, disclosure and protection of the information shared by You shall
          function upon visiting the Application and it applies to all users of
          all the services and products offered by us through our InstaPe App.{" "}
        </p>
        <p style={{ textAlign: "justify" }}>
          Our practices and procedures regarding the collection and use of
          Personal Information are outlined below to ensure safe use of the
          Services. We have implemented reasonable security practices and
          procedures appropriate to the nature of the information and our
          business. While we strive to provide security that exceeds industry
          standards, due to the inherent vulnerabilities of the internet, we
          cannot guarantee complete security of all information transmitted to
          us by you.
        </p>
        <p style={{ textAlign: "justify" }}>
          This Privacy Policy (or <b>“Policy”</b>) is in conjunction with
          Information Technology Act, 2000 read with Information Technology
          (Reasonable Security Practices and Procedures and Sensitive Personal
          Data or Information) Rules, 2011 in addition to more relevant
          guidelines of the Reserve Bank of India (hereinafter referred to as{" "}
          <b>“RBI”</b>) and various other applicable laws.{" "}
        </p>
        <p style={{ textAlign: "justify" }}>
          By accessing or using our Services, you agree to the collection and
          use of your information in accordance with this policy and applicable
          Indian data protection laws, including the Digital Personal Data
          Protection Act, 2023.{" "}
          <b>
            By checking the box, we assume that your consent is given freely and
            that you understand unambiguously and clearly how we will use your
            data and that you may, at any time, withdraw your consent
          </b>
          .{" "}
        </p>
        <p style={{ textAlign: "justify" }}>
          Kindly note that the terms and conditions mentioned in the Policy can
          be revised at any time by the Company in accordance with the latest
          guidelines, applicable laws and various business requirements of the
          Company. Any such revision would not be communicated separately to any
          User.{" "}
        </p>
        <p style={{ textAlign: "justify" }}>
          Your continued use of the InstaPe App after any changes to this Policy
          will mean that you agree to and accept such changes. Therefore, we
          strongly suggest that your review our Policy periodically to ensure
          familiarity with the Policy’s most current version.{" "}
        </p>
        <p style={{ textAlign: "justify" }}>
          We will post all changes to the Policy here so that you will always
          know what information we gather, how we might use that information,
          and when and how we will disclose that information.{" "}
        </p>
        <p style={{ textAlign: "justify" }}>
          You can tell if the Policy has been updated by checking the last
          revised date posted on the top of this page.
        </p>
        <p style={{ textAlign: "justify" }}>
          If, due to such changes, you decide that you want to delete any
          portion of your personal information from our database, please notify
          us at by following the procedure as laid down in this Policy with
          regard to deletion/withdrawal of Information.{" "}
        </p>
        <p style={{ textAlign: "justify" }}>
          This Privacy Policy is incorporated into and at all times is subject
          to and is to be read in conjunction with the Terms of Use of the
          Application.
        </p>
        <ol class="nested-list">
          <li>
            <b>CONSENT</b>
            <ol style={{ marginTop: 10 }}>
              <li>
                You hereby expressly consent to provide the information that may
                be required in relation to the Services (as defined below) being
                rendered on the Application by Us. You acknowledge that we shall
                collect the information detailed under this Privacy Policy to
                facilitate lending and non-lending services by partnering with
                various Lending Institutions, third parties, service providers,
                etc based on your requirement to avail such Services{" "}
                <b>(“Services”)</b>.{" "}
              </li>
              <li>
                To avail any Services being provided by the Application (through
                partnership with the Lending Institutions or any other third
                parties), it is mandatory that You read, understand, acknowledge
                and unconditionally agree to be bound by the terms and
                conditions of this Privacy Policy
              </li>
              <li>
                In an event You do not agree to this Policy or any part thereof,
                You are requested not to access/use the Application or avail
                such Services.
              </li>
            </ol>
          </li>
          <li>
            <b>COLLECTION OF INFORMATION</b>
            <ol>
              <li>
                For accessing and usage of our Services, We may collect
                information including but not limiting to:
                <ol className="alpha-nested">
                  <li>Name </li>
                  <li>Contact Number</li>
                  <li>Date of Birth </li>
                  <li>Gender</li>
                  <li>Email Id</li>
                  <li>Address (Temporary/Permanent) </li>
                  <li>
                    Employment details like name of your employer, your employee
                    ID, etc and any other employee information as may be
                    required for rendering services requested by You on the
                    Application and as requested by the Lending
                    Institutions/third parties providing the Services from time
                    to time.
                  </li>
                  <li>
                    In accordance with the RBI regulations, Lending Institutions
                    and/or third-party service providers may ask for additional
                    on-boarding/Know your Customer (KYC) documents via one-time
                    access through camera, microphone, location etc. The consent
                    for the same shall be acquired explicitly through You.{" "}
                  </li>
                  <li>
                    Usage Data - We may collect data as to how you interact with
                    the Application such as screen actions, dates and times of
                    access, pages viewed etc.
                  </li>
                </ol>
              </li>
              <li>
                The Application will share the information securely and ensure
                that all personal information recipients comply with
                confidentiality, fidelity and secrecy obligations and sign
                covenants in this regard. We may make information available to
                third parties that are financial and non financial companies,
                various service providers as requested by You or otherwise when
                required or permitted by law.
              </li>
              <li>
                We may use cookies through Application as the information helps
                Us identify You in order to make our Website/Application more
                user friendly. You may choose to decline the use of cookies,
                however, if You choose to do this it might affect Service on
                some parts of our Website/Application.
              </li>
              <li>
                Upon the collection of such data, during the process of data
                collection or any other stage that You choose to revoke consent
                to continue providing the data aforementioned, You shall have
                the right to deny usage of Personal Data collected at a
                prior-stage and/or specific data, restrict disclosure to third
                parties, disallow data retention and make the Application
                delete/forget any data as requested by You.
              </li>
              <li>
                Additionally, the revocation/deletion/restriction/denial of
                usage of the required data may result in a restricted
                functioning or in some cases, non-functioning of the Application
                as some of the Services can only be facilitated through
                collection of such data.
              </li>
              <li>
                The Application shall not be collecting any mobile phone
                resources like file and media, contact list, call logs,
                telephony functions and other relevant data unless expressly
                authorised by You for the facilitation of the functioning of the
                Services availed by the Application.
              </li>
              <li>
                It is also hereby declared that, in no circumstances unless
                mandated by the Law, do We collect any bio-metric data.
              </li>
            </ol>
          </li>
          <li>
            <b>DATA PROTECTION</b>
            <ol>
              <li>
                The Application shall allow access of Your data strictly to the
                authorised personnel only who would be involved in the
                transaction requested by You or involved in transmission of data
                from the Application to Lending Institutions/other service
                providers.
              </li>
              <li>
                We ensure that every data or information that We collect from
                You is stored in servers located in India and the same is in
                compliance with all the statutory/regulatory obligations.
              </li>
              <li>
                We shall, however, not be held liable for any loss or injury
                caused to You or any related/third party as a consequence of
                providing the data to the Application.
              </li>
              <li>
                Wherein the details of login are provided to You it shall be
                solely your responsibility to ensure the safe storage and
                non-disclosure of Your crucial login data.
              </li>
              <li>
                We shall ensure our policies and data protection mechanism are
                the most secure and reliable throughout. However, no
                transmission can be guaranteed to be privy of possibility of
                data breach and hence, We can promise maximum security as per
                our capacity but not absolute security. We will not be liable
                for any damages of any kind arising from the use of the
                platform, including, but not limited to any indirect,
                incidental, special, consequential or punitive damages, or any
                loss of profits or revenues, whether incurred directly or
                indirectly or any loss of data, use, good-will, or other
                intangible losses.
              </li>
            </ol>
          </li>
          <li>
            <b>PURPOSE OF DATA COLLECTION</b>
            <ol>
              <li>
                The purpose for the same shall be as below but not limited to,
                as per Applicable Laws:
                <ol className="alpha-nested">
                  <li>Establish customer identity and verify the same; </li>
                  <li>
                    Facilitate Your KYC as per instructions from the Lending
                    Institutions;
                  </li>
                  <li>
                    Troubleshoot problems, monitor, improve and administer our
                    Application;
                  </li>
                  <li>
                    Provide our Service i.e., facilitating loans to You or
                    providing our value-added Services or non-lending Services
                    to You.
                  </li>
                  <li>
                    Diagnose service or technical problems and ensure security;{" "}
                  </li>
                  <li>
                    Send communications, notifications, information regarding
                    the product(s) or service(s) requested by You or revert to
                    queries that You may have of the Application;{" "}
                  </li>
                  <li>
                    Protect consumer interest and satisfaction in our products
                    and Services.
                  </li>
                  <li>Manage customer relations; </li>
                  <li>
                    Marketing and promotional purposes including sending you
                    promotional SMS, Email and WhatsApp messages and inform You
                    about online and offline offers, products, services, and
                    updates;{" "}
                  </li>
                  <li>
                    Conduct data analysis in order to improve the Services /
                    Products provided to the User;{" "}
                  </li>
                  <li>To ensure compliance with laws and regulations; </li>
                  <li>
                    User information in other ways permitted by law to enable
                    You to take financial services from the Lending
                    Institutions.
                  </li>
                  <li>
                    Resolve disputes and detect and protect Us against
                    suspicious or illegal activity, fraud and other criminal
                    activity;{" "}
                  </li>
                  <li>
                    Customize your experience and enforce our terms and
                    conditions.
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <b>INFORMATION COLLECTED FROM THIRD PARTIES</b>
            <ol>
              <li>
                We shall collect information such as the number of days worked
                in a month, your name, address, other details from the human
                resource management platform of Your employer.{" "}
              </li>
            </ol>
          </li>
          <li>
            <b>DISCLOSURES</b>
            <ol>
              <li>
                We will share the information only in such manner as described
                below:
                <ol className="alpha-nested">
                  <li>
                    We may disclose and share Your information with the Lending
                    Institutions and other service providers for facilitation of
                    a loan or facility or line of credit or any
                    product/services;{" "}
                  </li>
                  <li>
                    We share Your information with our third-party partners in
                    order to conduct data analysis in order to serve You better
                    and provide Services our Application;{" "}
                  </li>
                  <li>
                    We may share Your information with another business entity
                    should We (or our assets) merge with, or be acquired by that
                    business entity, or re-organization, amalgamation,
                    restructuring of business for continuity of business. Should
                    such a transaction occur, then any business entity (or the
                    new combined entity) receiving any such information from Us
                    shall be bound by this Policy with respect to Your
                    information.{" "}
                  </li>
                  <li>
                    We will disclose the information to our third-party
                    technology or third-party data source providers, if any;{" "}
                  </li>
                  <li>
                    We will share Your information under a confidentiality
                    agreement with the third parties and restrict use of the
                    said information by third parties only for the purposes
                    detailed herein. We warrant that there will be no
                    unauthorised disclosure of your information shared with
                    third parties.{" "}
                  </li>
                  <li>
                    We shall disclose Your data to the relevant regulatory
                    authorities as a part of our statutory audit process.{" "}
                  </li>
                  <li>
                    We shall disclose Your data (i) as required by the law or in
                    order to comply with judicial proceedings, court orders or
                    legal or regulatory proceedings; (ii) necessary to protect
                    the safety of our employees, our property or the public and
                    (iii) necessary for the prevention or detection of crime,
                    including exchanging information with other companies or
                    organizations for the purposes of fraud protection and
                    credit risk reduction.{" "}
                  </li>
                </ol>
              </li>
              <li>
                By accepting this Privacy Policy, You hereby provide Your
                consent to disclose Your Personal Data for disclosures. At all
                stages, We shall seek Your consent for any disclosures with any
                other third party.{" "}
              </li>
            </ol>
          </li>
          <li>
            <b>DATA STORAGE AND DELETION</b>
            <ol>
              <li>
                We assure you that Your Personal Data will be protected from
                unauthorized access, misuse, and disclosure using the right
                security measures based on the type of data and how We are
                processing the same. We retain information about You to provide
                a seamless experience, to contact You in case of support
                required and about Your account, to detect, mitigate, prevent,
                and investigate fraudulent or illegal activities during the
                course of the Services.
              </li>
              <li>
                We shall store basic minimal data that may be required to carry
                out Our services that are requested by You through our
                Application in compliance with the Applicable Laws and RBI
                Guidelines in place. For accessing and usage of our Services, We
                may store information including but not limiting to those
                mentioned in Clause 2.1:
              </li>
              <li>
                Subject to the RBI Guidelines, the data that is stored as
                mentioned in this Clause shall be preserved for a reasonable
                period of time.
              </li>
              <li>
                It is hereby declared that the data shall be stored while
                ensuring that highest security standards are being complied with
                while handling of such data and prevent any breaches, thereof;
                that may arise.{" "}
              </li>
              <li>
                Subject to this section, We may delete your data upon reasonable
                written request for the same at any stage. However, You may not
                be able to use our Services after deletion.
              </li>
            </ol>
          </li>
          <li>
            <b>THIRD PARTY COMPLIANCES </b>
            <ol>
              <li>
                As per this Privacy Policy, we are only addressing the
                disclosure and use of data collected by Us. The data collection
                practices of a third party which may be providing services to
                You under the aegis of our application, and their policies might
                be different from this Policy, and We do not have control over
                any of their policies neither do We have any liability in this
                regard.{" "}
              </li>
            </ol>
          </li>
          <li>
            <b>INFORMATION COLLECTED BY INSTAPE APP YOUR RIGHTS AGAINST IT </b>
            <ol>
              <li>
                In an event You find that the data/information provided by You
                is inaccurate, incomplete and/or outdated, You shall have the
                right to inform Us of the same or make the changes on Your end
                immediately.
              </li>
              <li>
                Your Privacy Controls: You have certain choices regarding the
                information We collect and how it is used:
                <ol className="alpha-nested">
                  <li>
                    Your device may have controls that determine what
                    information We collect. For example, You can modify
                    permissions on Your Android/iOS device or browser to remove
                    any permissions that may have been given. However, the
                    Application does not provide a guarantee of Services if any
                    such controls are exercised.
                  </li>
                  <li>Delete the Application from Your device</li>
                </ol>
              </li>
              <li>
                Withdrawal/Denial of Consent: You acknowledge that the
                Application has duly collected the information with Your
                consent, and You have the option to not provide such information
                or deny consent for use of specific information or revoke the
                consent already given. However, any withdrawal of such personal
                information will not be permitted in case any Service availed by
                You is active. Where a consent has been withdrawn, the
                Application does not guarantee or be liable for providing such
                Service.
              </li>
              <li>
                However, We, shall not retain Your data and information if it is
                no longer required by Us and there is no legal requirement to
                retain the same. Do note that multiple legal bases may exist in
                parallel, and We may still have to retain certain data and
                information at any time. Also, the information may still be used
                for execution of any outstanding or termination activity of any
                lending or non-lending Services.
              </li>
              <li className="no-style">
                We declare that:
                <ol className="bullet-nested">
                  <li>
                    We use encryption to keep your data private while in rest
                    and transit;
                  </li>
                  <li>
                    We offer security feature like an OTP verification to help
                    You protect your account;{" "}
                  </li>
                  <li>
                    We review our information collection, storage, and
                    processing practices, including physical security measures,
                    to prevent unauthorized access to our systems;{" "}
                  </li>
                  <li>
                    We restrict access to personal information to our employees,
                    contractors, and agents who need that information in order
                    to process it. Anyone with this access is subject to strict
                    contractual confidentiality obligations and may be
                    disciplined or terminated if they fail to meet these
                    obligations;{" "}
                  </li>
                  <li>
                    Compliance & Cooperation with Regulations and applicable
                    laws;{" "}
                  </li>
                  <li>
                    We regularly review this Privacy Policy and make sure that
                    We process your information in ways that comply with it.
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <b> CHILDREN’S DATA</b>
            <ol>
              <li>
                Our services are not intended for individuals below 18 years of
                age. We do not knowingly collect personal data from minors.
              </li>
            </ol>
          </li>
          <li>
            <b>UPDATES TO THIS POLICY </b>
            <ol>
              <li>
                We may from time to time amend the terms of this Policy, at our
                absolute discretion, to ensure that this Policy is consistent
                with our future developments, industry trends and/or any changes
                in legal or regulatory requirements. Subject to your rights at
                law, you agree to be bound by the prevailing terms of this
                Policy as updated from time to time on our Platform.{" "}
              </li>
              <li>
                We, InstaPe App, hereby reserve the right to change, modify,
                add, or remove portions of this Privacy Policy at any time for
                any reason. In case, any changes are made in the Privacy Policy,
                We shall update the same on the Application. We encourage You to
                periodically review this page for the latest information on our
                privacy practices. Your continued access or use of the Services
                constitute Your acceptance of the changes and the amended
                Privacy Policy.
              </li>
            </ol>
          </li>
          <li>
            <b>DATA BREACH NOTIFICATION </b>
            <ol>
              <li>
                In the event of a breach security leading to accidental or
                unlawful destruction, loss, alteration, unauthorized disclosure
                of, or access to, Personal Data, we shall promptly assess the
                impact and once assessed that it is a notifiable data breach, we
                shall report this breach as per the provisions of applicable
                law. InstaPe will notify the customers without undue delay,
                within 24 hours after establishing that the data breach is
                likely to result in significant harm or impact to the
                individuals to whom the individual relates, or of a significant
                scale.
              </li>
              <li className="no-style">
                <b>Issues and Grievances:</b>
              </li>
              <li className="no-style">
                If You have any complaints, grievances or You wish to report any
                issue or security incident related to the InstaPe App and other
                content and services, please reach out to our Grievance
                Redressal Officer by email on: nodalofficer@instape.com
              </li>
            </ol>
          </li>
        </ol>
      </div>
    </>
  );
};

export default Policy;
